<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'PFormationSectionVariante'
});
</script>
<template>
  <ka-container
    code="p-formation-section-variante"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Container 1 -->
    <ka-container code="container-1">
      <ka-text
        code="text"
        :value="componentInstance.$title.value" />
      <ka-text code="jaaaadis-le-discours">
        <span v-html="t('pFormationSectionVariante.container1.jaaaadisLeDiscours.value', `Jaaaadis, le discours du parfait commercial commençait par un “TOC TOC”. Et oui, l’ancêtre du message LinkedIn automatisé envoyé à 200 contacts en quelques minutes est en quelque sorte le porte-à-porte. Aujourd’hui les <strong>canaux</strong> <strong>de prospection</strong> peuvent être 100% digitaux, et ils représentent un <strong>choix stratégique</strong> pour l’entreprise.`)" />
      </ka-text>
      <!-- Container -->
      <ka-container code="container">
        <ka-text code="text-gauche">
          <span v-html="t('pFormationSectionVariante.container1.container.textGauche.value', `❌  <strong>Ne pas s’éparpiller dans l'élaboration du discours commercial</strong>`)" />
        </ka-text>
        <ka-text code="text-droite">
          <span v-html="t('pFormationSectionVariante.container1.container.textDroite.value', `<strong>❌  Ne pas concentrer son énergie sur des canaux où sa cible n’est pas présente</strong>`)" />
        </ka-text>
      </ka-container>
      <ka-text code="conseils-evidents-mais">
        <span v-html="t('pFormationSectionVariante.container1.conseilsEvidentsMais.value', `Conseils évidents mais pas toujours mis en pratique ! L’intervention d’un expert en business development sur la stratégie existante dans votre entreprise et ses conseils d’amélioration peuvent vous permettre de <strong>réorienter ou organiser votre stratégie</strong> pour booster votre activité !`)" />
      </ka-text>
    </ka-container>
    <ka-image
      code="image"
      :options="{
        animationIn: `fadeIn`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        imgFit: `cover`,
        alt: `Image`
      }"
      value="https://ucarecdn.com/7e32bd81-bcff-4b97-9726-bc26f452ca42/" />
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { pFormationSectionVarianteComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c36')
const component = pFormationSectionVarianteComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  title?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  title: undefined,
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:title'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: { title: true }
})
</script>
